export default {"src":"/_next/static/media/ETRN.50e6a797.svg","height":18,"width":18};